class HeaderHeight {
  constructor() {
    this.header = null;
    this.isInitialized = false;
  }

  shouldInit() {
    return document.body.classList.contains('layout-HomeOneColumn');
  }

  init() {
    if (!this.shouldInit() || this.isInitialized) return;

    this.header = document.querySelector('header.Header');
    if (!this.header) return;

    this.setHeaderHeight();
    this.bindEvents();
    this.isInitialized = true;
  }

  setHeaderHeight() {
    if (!this.header) return;

    const headerHeight = this.header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight + 'px'
    );
  }

  bindEvents() {
    window.addEventListener('resize', () => this.setHeaderHeight());
    window.addEventListener('orientationchange', () => {
      setTimeout(() => this.setHeaderHeight(), 100);
    });
  }

  destroy() {
    if (!this.isInitialized) return;

    document.documentElement.style.removeProperty('--header-height');
    this.isInitialized = false;
  }
}

export default HeaderHeight;
